<template><section><h3>面向海洋生态环境安全的海洋复合极端事件智能识别与多尺度演变分析系统（如高温-缺氧-酸化）</h3>
<h4>项目背景：</h4>
<p>海洋是地球气候系统的核心调节器和全球生物多样性的宝库。维持海洋生态环境安全，不仅关乎海洋渔业资源的可持续利用、海岸带经济的稳定，更是应对全球气候变化、保障人类生存福祉的关键基础。海洋极端事件（如海洋热浪、缺氧、酸化）是指海洋物理或生化要素偏离正常状态的异常现象。单一要素的极端变化已对珊瑚礁、海草床等脆弱生态系统造成严重威胁。然而，当高温、缺氧和酸化在同一海域、同一时段叠加发生（即复合极端事件） 时，会通过加速生物代谢、降低氧气溶解度、破坏碳酸盐体系等机制，产生“1+1+1&gt;3”的非线性协同破坏效应。这种复合风险极易导致大面积生物死亡、栖息地丧失等不可逆的生态灾难，是当前海洋生态环境安全面临的最严峻挑战之一。</p>
<p>目前，海洋学研究多聚焦于单一要素的统计分析，缺乏能够直观探索多要素时空耦合关系的交互式工具。本项目拟构建一套海洋复合极端事件智能识别与多尺度演变可视分析系统。系统基于阈值与无监督聚类方法，对预处理后的海洋环境数据进行高温-缺氧-酸化事件的提取；并通过多视图协同交互（Multi-view Coordination） 设计，将复杂的时空演变过程转化为直观的视觉编码，帮助领域专家和学习者直观洞察复合事件的触发机制、演变规律及协同效应。</p>
<p>核心科学依据包括 Nature 综述《Biogeochemical extremes and compound events in the ocean》以及 Nature Communications 研究《Extreme compound events in the equatorial and South Atlantic》。二者分别提供复合生物地球化学极端事件的概念框架和多要素共现概率分析范例。</p>
<h4>项目要求：</h4>
<ol>
<li>
<p>建立可追溯的多源海洋生态环境数据底座。统一 SST、温盐、溶解氧、pH、氢离子浓度、表层二氧化碳分压和辅助环流变量的名称、单位、时间历法、经纬度范围、垂向坐标、掩膜和版本信息。</p>
<ul>
<li>自动检查时间覆盖和缺测；</li>
<li>自动记录数据产品、数据集标识和下载日期；</li>
<li>支持固定区域裁剪、分块缓存和断点续传；</li>
<li>生成可供复现实验的 manifest 清单。</li>
</ul>
</li>
<li>
<p>识别单一极端事件及其三维对象。</p>
<ul>
<li>分别为海洋高温、低氧和高酸度建立季节变化阈值，输出事件起止、持续时间、峰值强度、平均强度、累计超阈强度、最大面积或体积、质心轨迹和受影响深度范围。</li>
</ul>
</li>
<li>
<p>识别双要素与三要素复合事件。</p>
<ul>
<li>在共同空间网格、共同深度层和共同时间单位上识别高温—缺氧、高温—酸化、缺氧—酸化及高温—缺氧—酸化事件，输出共现时长、组合类型、重叠比例、先后顺序、条件概率和协同放大指数。</li>
</ul>
</li>
<li>
<p>形成多尺度频率与演变诊断。</p>
<ul>
<li>统计天气尺度事件簇、季节内活跃期、年际异常和年代际变化，支持月历、季节玫瑰图、年际序列、滑动窗口趋势和区域热点图。</li>
</ul>
</li>
<li>
<p>开展趋势和驱动分解。</p>
<ul>
<li>评估单要素和复合事件的频率、持续时间、强度、空间范围和季节相位漂移，区分长期背景变化、季节循环、气候模态、局地动力过程及随机残差的贡献。</li>
</ul>
</li>
<li>
<p>构建受约束的离线 AI 分析助手。</p>
<ul>
<li>AI 只负责任务解析、工具选择、结果解释和下一步建议；阈值计算、事件识别、概率统计、趋势检验和图形数据全部由可复核的专业程序完成。</li>
</ul>
</li>
</ol>
</section></template><script>export default {components:{}}</script>